import { avecLibelleTraduit } from '../i18n/libelles';

// Reste en français : libellePrejudice() ne sert qu'aux documents imprimés
// (ordre de dépense, quittance), dont la langue est celle du destinataire.
export const TYPE_PREJUDICE_LIBELLE = {
    MATERIEL: 'Préjudice matériel',
    CORPOREL: 'Préjudice corporel',
    MORAL: 'Préjudice moral',
};

// Options d'écran : libellé traduit à la lecture (referentiels:typesPrejudice).
export const TYPE_PREJUDICE_OPTIONS = avecLibelleTraduit(Object.keys(TYPE_PREJUDICE_LIBELLE).map(
    (value) => ({ value })
), 'referentiels:typesPrejudice');

export const libellePrejudice = (type) => TYPE_PREJUDICE_LIBELLE[type] || '';
